(function ($) {
  document.addEventListener("DOMContentLoaded", function() {

    const body = document.querySelector('html > body.single-product');

    if (body) {

      const lecturerSliderSection = body.querySelector('.single-product-lecturer-slider');

      if (lecturerSliderSection) {

        const course_nr = lecturerSliderSection.dataset.kursnr;

        if (course_nr) {

          let currentSlideIndex = 0;
          let highestLoadedSlide = -1;
          let metisLastPage = 1;

          const lecturerSliderImage = $('.single-product-lecturer-slider__image-slider');
          const lecturerSliderContent = $('.single-product-lecturer-slider__content-slider');

          const lecturerSliderNavButtonPrev = lecturerSliderSection.querySelector('.single-product-lecturer-slider__nav-button-container.prev');
          const lecturerSliderNavButtonNext = lecturerSliderSection.querySelector('.single-product-lecturer-slider__nav-button-container.next');

          lecturerSliderNavButtonPrev.addEventListener('click', function () {
            // console.log('metisLastPage: ', metisLastPage, '  nextMetisPage: ', highestLoadedSlide + 2, '  highestSlide: ',highestLoadedSlide, '  nextSlide: ', highestLoadedSlide + 1, 'currentSlideIndex: ', currentSlideIndex);

            if(currentSlideIndex - 1 < 0 && highestLoadedSlide + 1 < metisLastPage) {
              lecturerSliderLoad(highestLoadedSlide + 2);
            } else {
              const nextIndex = getPrevSlide();
              lecturerSliderImage.slick('slickGoTo', nextIndex);
              lecturerSliderContent.slick('slickGoTo', nextIndex);
              setColors(currentSlideIndex, nextIndex);
              currentSlideIndex = nextIndex;
            }
          });
          lecturerSliderNavButtonNext.addEventListener('click', function () {
            // console.log('metisLastPage: ', metisLastPage, '  nextMetisPage: ', highestLoadedSlide + 2, '  highestSlide: ',highestLoadedSlide, '  nextSlide: ', highestLoadedSlide + 1, 'currentSlideIndex: ', currentSlideIndex);

            if (currentSlideIndex + 1 > highestLoadedSlide && highestLoadedSlide + 1 < metisLastPage) {
              lecturerSliderLoad(highestLoadedSlide + 2);
            } else {
              const nextIndex = getNextSlide();
              lecturerSliderImage.slick('slickGoTo', nextIndex);
              lecturerSliderContent.slick('slickGoTo', nextIndex);
              setColors(currentSlideIndex, nextIndex);
              currentSlideIndex = nextIndex;
            }
          });

          lecturerSliderLoad(1);

          function lecturerSliderLoad(page) {

            // console.log('load metis page ', page);

            $.ajax({
              type: 'post',
              url: ajaxurl,
              data: {action: 'course_lecturer_slider', page: page, kursnr: course_nr},
              success: function (response) {
                const parser = new DOMParser();
                const html = parser.parseFromString(response, 'text/html');

                const lastPage = html.querySelector('#lastPage')?.dataset?.lastpage;
                const imageHTML = html.querySelector('#image');
                const contentHTML = html.querySelector('#content');

                if(lastPage && imageHTML && contentHTML) {

                  metisLastPage = parseInt(lastPage);
                  setColors(currentSlideIndex, page - 1);
                  currentSlideIndex = page - 1;
                  highestLoadedSlide += 1;
                  // console.log('new metis last page: ', metisLastPage, '  newHighestLoadedSlide: ', highestLoadedSlide);

                  lecturerSliderImage.slick('slickAdd', imageHTML.innerHTML);
                  lecturerSliderContent.slick('slickAdd', contentHTML.innerHTML);

                  lecturerSliderImage.slick('slickGoTo', currentSlideIndex);
                  lecturerSliderContent.slick('slickGoTo', currentSlideIndex);

                  if (page == 1 && metisLastPage > 1) {
                    lecturerSliderNavButtonPrev.classList.add('visible');
                    lecturerSliderNavButtonNext.classList.add('visible');
                  }
                } else {
                  lecturerSliderSection.classList.add('d-none');
                }
                document.dispatchEvent(new CustomEvent("product-lecturer-slider-updated"));
              },
              error: function () {
                  console.log("Error");
              }
            });
          }

          const arrows = lecturerSliderSection.querySelectorAll(".single-product-lecturer-slider__nav-button-container");
          const arrowPaths = lecturerSliderSection.querySelectorAll(".single-product-lecturer-slider__nav-button-container path");
          const desktopBG = lecturerSliderSection.querySelector(".single-product-lecturer-slider__bg-desktop");
          const desktopImageOverlay = lecturerSliderSection.querySelector(".single-product-lecturer-slider__image__overlay");

          const bgColors = [
            ["bg-classic-primary", "bg-dark-grass", "bg-pride-grass", "bg-pastel-grass-light"],
            ["bg-classic-primary", "bg-dark-grass", "bg-pride-orange", "bg-pastel-orange-light"],
            ["bg-classic-primary", "bg-dark-grass", "bg-pride-cherry", "bg-pastel-cherry-light"],
          ];
          const buttonColors = [
            ["bg-classic-cherry", "bg-dark-grey-medium", "bg-pride-violet", "bg-pastel-indigo-light"],
            ["bg-classic-cherry", "bg-dark-grey-medium", "bg-pride-sky", "bg-pastel-turquoise-light"],
            ["bg-classic-cherry", "bg-dark-grey-medium", "bg-pride-lemon", "bg-pastel-lemon-light"],
          ];
          const buttonBorders = [
            ["border-classic-white", "border-dark-white", "border-pride-white", "border-pastel-grass-light"],
            ["border-classic-white", "border-dark-white", "border-pride-white", "border-pastel-orange-light"],
            ["border-classic-white", "border-dark-white", "border-pride-white", "border-pastel-cherry-light"],
          ];
          const buttonFills = [
            ["fill-classic-white", "fill-dark-white", "fill-pride-white", "fill-pastel-grass-light"],
            ["fill-classic-white", "fill-dark-white", "fill-pride-white", "fill-pastel-orange-light"],
            ["fill-classic-white", "fill-dark-white", "fill-pride-white", "fill-pastel-cherry-light"],
          ];

          const setColors = (slideIndex, nextIndex) => {
            arrows.forEach(arrow => {
              buttonColors[slideIndex % 3].forEach(c => arrow.classList.remove(c));
              buttonColors[nextIndex % 3].forEach(c => arrow.classList.add(c));

              buttonBorders[slideIndex % 3].forEach(c => arrow.classList.remove(c));
              buttonBorders[nextIndex % 3].forEach(c => arrow.classList.add(c));
            });

            arrowPaths.forEach(arrowPath => {
              buttonFills[slideIndex % 3].forEach(c => arrowPath.classList.remove(c));
              buttonFills[nextIndex % 3].forEach(c => arrowPath.classList.add(c));
            });

            bgColors[slideIndex % 3].forEach(c => desktopBG.classList.remove(c));
            bgColors[nextIndex % 3].forEach(c => desktopBG.classList.add(c));

            bgColors[slideIndex % 3].forEach(c => desktopImageOverlay.classList.remove(c));
            bgColors[nextIndex % 3].forEach(c => desktopImageOverlay.classList.add(c));
          };

          const getNextSlide = () => {
            if (currentSlideIndex + 1 > highestLoadedSlide) {
              return 0;
            } else {
              return currentSlideIndex + 1;
            }
          }
          const getPrevSlide = () => {
            if (currentSlideIndex - 1 < 0) {
              return highestLoadedSlide;
            } else {
              return currentSlideIndex - 1;
            }
          }
        }
      }
    }
  });
})(jQuery);

